require('./dealer-ctas.tag');
require('../raw-html.tag');

riot.tag2('dealer', '<div class="dealer {\'is-preferred\': dealer.preferred, \'is-selected\': dealer.selected}"> <span class="dealer-preferred-message" if="{dealer.preferred}">{labels.yourPreferredDealer}</span> <div class="dealer-header"> <div class="dealer-index" onclick="{selectDealer}" data-tracking="{trackingDataDealerIndex}">{index + 1}</div> <h2 class="dealer-name acr-secondary-title-5" onclick="{viewDetails}" data-tracking="{trackingDataDealerDetails}">{dealer.Name}</h2> <div hide="{dealer.IsServiceCenter}" class="dealer-preferred-box" onclick="{setPreferred}" ontouchstart="{setPreferred}" onmouseleave="{offHover}" onmouseenter="{onHover}"> <span class="dealer-tooltip acr-paragraph-7" if="{hovered}">{dealer.preferred?labels.yourPreferredDealer:labels.preferredDealerTooltip}</span> <i class="{\'dl-icon-preferred-dealer\': !dealer.preferred, \'dl-icon-preferred-dealer-selected\': dealer.preferred}"></i> </div> </div> <div class="dealer-content acr-paragraph-5"> <div class="dealer-directions"> <a href="{directions}" target="_blank" data-tracking="{trackingDataDirection}"> <i class="dl-icon-address"></i> </a> <div class="dealer-box"> <div class="dealer-distance" if="{dealer.DrivingDistanceMiles}">{dealer.DrivingDistanceMiles} {labels.milesText}</div> <a href="{directions}" target="_blank" class="dealer-address" data-tracking="{trackingDataDirection}"> <raw-html content="{fullAddress}"></raw-html> </a> </div> </div> <div class="dealer-phone"> <a href="tel:{formatter.phone(dealer.Phone)}" data-tracking="{trackingDataPhone}"> <i class="dl-icon-phone"></i> </a> <a class="dealer-box" href="tel:{formatter.phone(dealer.Phone)}" data-tracking="{trackingDataPhone}"> <span>{formatter.phone(dealer.Phone)}</span> </a> </div> </div> <dealer-ctas dealer="{dealer}" dealer-index="{index + 1}" is-start-reservation="{isStartReservation}"></dealer-ctas> </div>', '', 'class="dealer-container"', function(opts) {
    var self = this;
    var trackingJSON = require('../../data/tracking-data');
    var constants = require('../../core/constants.js');

    this.mixin('bus');

    self.hovered = false;
    self.fullAddress = `${self.dealer.Address}</br> ${self.dealer.City}, ${self.dealer.State} ${self.dealer.ZipCode.slice(0, 5)}`;
    self.directions = self.labels.bingMapsDirections
                      + self.fullAddress.replace('</br>', '').replace(/[ ]/g, '%20');
    self.isStartReservation = window.dealerLocator && window.dealerLocator.isStartReservation;
    function triggerTrackingDataPreferred() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.preferredDealer));
      jsonData.Dealer.selected_dealer_id = self.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.dealer.Name;
      jsonData.Dealer.selected_dealer_address = self.dealer.Address + ', ' + self.dealer.City;
      jsonData.dynamic_variables[2].search += 'results';

      if (self.dealer.preferred) {
        jsonData.dynamic_variables[0].search += 'results:deselect preferred dealer';
      } else {
        jsonData.dynamic_variables[0].search += 'results:select preferred dealer';
      }
      if (window.Acr.TrackingManager) {
        window.Acr.TrackingManager.clickActivity(jsonData);
      }
    }

    function setPreferred() {
      triggerTrackingDataPreferred();
      if (!self.dealer.preferred) {
        self.bus.trigger(self.bus.EVENTS.DEALERS.SET_PREFERRED,
          {
            DealerNumber: self.dealer.DealerNumber,
            DealerName: self.dealer.Name,
          });
      } else {
        self.bus.trigger(self.bus.EVENTS.DEALERS.UNSET_PREFERRED);
      }
    }

    function selectDealer() {
      self.bus.trigger(self.bus.EVENTS.DEALERS.SELECT,
        {
          index: self.index,
        });
    }

    function viewDetails() {
      self.bus.trigger(self.bus.EVENTS.DEALERS.OPEN_DETAIL,
        {
          index: self.index,
        });
    }

    function offHover() {
      self.hovered = false;
    }

    function onHover() {
      self.hovered = true;
    }

    function setTrackingDataDealerIndex() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.selectDealer));
      jsonData.Dealer.selected_dealer_id = self.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.dealer.Name;
      jsonData.Dealer.selected_dealer_address = `${self.dealer.Address}, ${self.dealer.City}`;

      self.trackingDataDealerIndex = JSON.stringify(jsonData);
    }

    function setTrackingDataDealerDetails() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.viewDealerDetails));
      jsonData.Dealer.selected_dealer_id = self.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.dealer.Name;
      jsonData.Dealer.selected_dealer_address = `${self.dealer.Address}, ${self.dealer.City}`;

      self.trackingDataDealerDetails = JSON.stringify(jsonData);
    }

    function setTrackingDataDirection() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.dealerDirections));
      jsonData.Dealer.selected_dealer_id = self.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.dealer.Name;
      jsonData.Dealer.selected_dealer_address = self.dealer.Address + ', ' + self.dealer.City;

      jsonData.dynamic_variables[0].search += 'results:[selected_dealer_name] directions';
      jsonData.dynamic_variables[2].search += 'results';

      self.trackingDataDirection = JSON.stringify(jsonData);
    }

    function setTrackingDataPhone() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.dealerTelephone));
      jsonData.Dealer.selected_dealer_id = self.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.dealer.Name;
      jsonData.Dealer.selected_dealer_address = self.dealer.Address + ', ' + self.dealer.City;
      jsonData.Dealer.selected_dealer_phone_number = self.dealer.Phone;

      jsonData.dynamic_variables[0].search += 'results:call [selected_dealer_name]';
      jsonData.dynamic_variables[2].search += 'results';

      self.trackingDataPhone = JSON.stringify(jsonData);
    }

    function clean() {
      self.unmount(false);
    }
    this.on('mount', function onMount() {
      setTrackingDataDealerIndex();
      setTrackingDataDealerDetails();
      setTrackingDataDirection();
      setTrackingDataPhone();
      setTrackingDataDirection();
    });
    self.bus.on(self.bus.EVENTS.FILTERS.SELECT, clean);

    self.selectDealer = selectDealer;
    self.setPreferred = setPreferred;
    self.viewDetails = viewDetails;
    self.offHover = offHover;
    self.onHover = onHover;
});
